import React from "react";

export default function AboutUsPage() {
    return (
        <div className="page--AboutUsPage stack-gap">
            <section className="section-gap stack-gap glass p-6 rounded-major shadow-glass">
                <h2 className="gc-heading text-2xl jade">Our Vision</h2>
                <p>In the face of the existential threat of climate change, the only way to find a better future, is with love.</p>
                <p>
                    By telling the stories of the brave Guardians already doing incredible work, we are inviting the concerned majority to take responsibility for what they love. To stand up to the powers that be with a unified voice.
                </p>
                <p>
                    The more brave guardians that take a stand on climate change, the more political leverage the Fossil Fuel Treaty has to convince the world's governments to make change.
                </p>
                <p>
                    By bringing these stories and Guardians together, we are building a community of support that surfaces serious projects early and surrounds them with the right humans and technology to help them move forward with integrity.
                </p>
                <p>In 40 years the question that will define our legacy is: "What did you do to fight climate change?"</p>
                <p>It is our responsibility to ensure we can answer with pride, "I was a Guardian, I protected what I love and thats why it's still here."</p>
            </section>

            <section className="section-gap stack-gap glass p-6 rounded-major shadow-glass">
                <h2 className="gc-heading text-2xl jade">About Us</h2>
                <p>
                    The Guardians Collective is an independent organization in direct support of the Fossil Fuel
                    <br />
                    Treaty.
                </p>

                <h3 className="gc-heading text-xl jade">Our Team</h3>
                <p>Omino Gardezi<br />Leadership & Relationships</p>
                <p>Quinn Berman-Hatch<br />Operations</p>
                <p>Scott Vance<br />Technology</p>
                <p>Elijah Blaugnelson<br />Technology</p>

                <h3 className="gc-heading text-xl jade">Founding Governing Body</h3>
                <p>Tzeporah Berman<br />Chair - Fossil Fuel Treaty</p>
                <p>Kumi Naidoo<br />President - Fossil Fuel Treaty</p>
            </section>
        </div>
    );
}